import { PublicError } from "@/domain/errors/common";

const ERROR_MESSAGES = {
  USER_NOT_FOUND: "No se encontró la cuenta de usuario",
  GET_USER_ERROR:
    "Ha ocurrido un error al intentar obtener la cuenta de usuario",
  PASSWORD_RESET_ERROR:
    "Ha ocurrido un error al intentar restablecer la contraseña",
  PASSWORD_RESET_TRIGGER_ERROR:
    "Ha ocurrido un error al intentar el restablecimiento de contraseña",
  UPDATE_USER_ERROR:
    "Ha ocurrido un error al intentar actualizar la cuenta de usuario",
  GET_USER_PREFERENCES_ERROR:
    "Ha ocurrido un error al intentar obtener las preferencias del usuario",
  UPDATE_USER_PREFERENCES_ERROR:
    "Ha ocurrido un error al intentar actualizar las preferencias del usuario",
  CREATE_USER_PREFERENCES_ERROR:
    "Ha ocurrido un error al intentar crear las preferencias del usuario",
  USER_PREFERENCES_NOT_FOUND: "No se encontraron las preferencias del usuario",
  DELETE_USER_PREFERENCES_ERROR:
    "Ha ocurrido un error al intentar eliminar las preferencias del usuario",
};

// * User Errors

class UserNotFoundError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.USER_NOT_FOUND);
  }
}

class GetUserError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.GET_USER_ERROR);
  }
}

class PasswordResetError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.PASSWORD_RESET_ERROR);
  }
}

class PasswordResetTriggerError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.PASSWORD_RESET_TRIGGER_ERROR);
  }
}

class UpdateUserError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.UPDATE_USER_ERROR);
  }
}

// * User Preferences Errors

class GetUserPreferencesError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.GET_USER_PREFERENCES_ERROR);
  }
}

class UpdateUserPreferencesError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.UPDATE_USER_PREFERENCES_ERROR);
  }
}

class UserPreferencesNotFoundError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.USER_PREFERENCES_NOT_FOUND);
  }
}

class CreateUserPreferencesError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.CREATE_USER_PREFERENCES_ERROR);
  }
}

class DeleteUserPreferencesError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.DELETE_USER_PREFERENCES_ERROR);
  }
}

export {
  DeleteUserPreferencesError,
  UserNotFoundError,
  GetUserError,
  PasswordResetError,
  PasswordResetTriggerError,
  UpdateUserError,
  GetUserPreferencesError,
  UpdateUserPreferencesError,
  CreateUserPreferencesError,
  UserPreferencesNotFoundError,
};
